export default ($axios) => ({
    $axios,

    async fetch() {
        return await $axios.get('/skills')
    },

    async add(form) {
        return await $axios.post('/skills', form)
    },

    async update(skill_id, form) {
        return await $axios.put(`/skills/${skill_id}`, form)
    },

    async remove(skill_id) {
        return await $axios.delete(`/skills/${skill_id}`)
    },

    async requestForDelete(skill_id) {
        return await $axios.post(`/skills/${skill_id}/markToRemove`)
    },
})
